import { combine, withSnakeCaseKeys } from '@datadog/browser-core';
export function startInternalContext(applicationId, session, parentContexts, configuration) {
    return {
        get: function (startTime) {
            if (configuration.isEnabled('v2_format')) {
                var viewContext = parentContexts.findViewV2(startTime);
                if (session.isTracked() && viewContext && viewContext.session.id) {
                    return withSnakeCaseKeys(combine({
                        application: {
                            id: applicationId,
                        },
                    }, viewContext, parentContexts.findActionV2(startTime)));
                }
            }
            else {
                var viewContext = parentContexts.findView(startTime);
                if (session.isTracked() && viewContext && viewContext.sessionId) {
                    return withSnakeCaseKeys(combine({ applicationId: applicationId }, viewContext, parentContexts.findAction(startTime)));
                }
            }
        },
    };
}
//# sourceMappingURL=internalContext.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/esm/domain/internalContext.js
// module id = mfJq
// module chunks = 1